import { render, staticRenderFns } from "./IconWarning.vue?vue&type=template&id=29dad543&scoped=true&"
import script from "./IconWarning.vue?vue&type=script&lang=js&"
export * from "./IconWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29dad543",
  null
  
)

export default component.exports